module.exports = __webpack_public_path__ + "static/media/blank.b6681619.png";